import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Component, signal } from '@angular/core';
import {  RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { finalize, interval, Subscription, take } from 'rxjs';

import { FilledInputDirective } from '@shared/directives/filledInput.directive';
import { AuthService } from '@app/features/auth/services/auth.service';
import { Spinner } from '@shared/components/spinner/spinner';
import { Utility } from '@common/utility';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule , FormsModule , ReactiveFormsModule , FilledInputDirective , RouterModule , Spinner , NgOptimizedImage],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss'
})
export class ForgotPassword {
  forgotForm : FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  loader = signal(false);
  isShowForgotPassword! : boolean;
  isResetBtnDisabled = signal(true);
  buttonText = signal('02:00');
  isForgotPassword : boolean= false
  private countdownSubscription: Subscription | null = null;
  constructor(private fb: FormBuilder, private authService: AuthService,  public utility : Utility) {
     this.forgotForm = this.fb.group({
      email: ['', Validators.required],
    })
  }
  ngOnInit(): void {

  }
  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  mapErrors(json: any) {
   if (json?.email) {
       this.forgotForm.get('email')?.setErrors({ serverError: json.email[0] })
    }
  }
  startCountdown(duration: number) {
    this.isResetBtnDisabled.set(true) 
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    this.updateButtonText(duration);
    this.countdownSubscription = interval(1000)
      .pipe(take(duration))
      .subscribe({
        next: (elapsed) => {
          const timeLeft = duration - elapsed - 1;
          this.updateButtonText(timeLeft);
        },
        complete: () => {
             this.isResetBtnDisabled.set(false) 
        },
      });
  }

  private updateButtonText(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const mm = minutes < 10 ? '0' + minutes : minutes;
    const ss = secs < 10 ? '0' + secs : secs;
    this.buttonText.set(`${mm}:${ss}`);
  }
  sendEmail() {
      this.loader.set(true)
       this.authService.forgotPassword(this.forgotForm.value).pipe(finalize(() => {
          this.loader.set(false)
      })).subscribe({
      next: (res) => {
        if(res.success === true) {
          localStorage.setItem('forgotPassword-email' , this.forgotForm?.value?.email)
        this.isForgotPassword = true
        this.startCountdown(12)
        }
      },
      error: (err) => {
        this.mapErrors(err?.error?.errors);
      },
    })
  }
  resendEmail() : void {
    this.startCountdown(20)
    const email = localStorage.getItem('forgotPassword-email')
    const data  = {
         email : email
    }
   this.authService.forgotPassword(data).subscribe()
  }
}
